import React from 'react'
import { Heading } from '@scentregroup/ui'
import style from './index.module.scss'

const ProductTitle: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }): JSX.Element => {
  return <Heading className={style.productTitle}>{children}</Heading>
}

export default ProductTitle
